import { Component } from 'react';
import { BotaoTentar, Falha } from './ChatIaFlutuante.styles';

/**
 * Pega a falha ao baixar a janela (chunk antigo após um deploy, sem rede) para não derrubar o app.
 * "Tentar de novo" chama `aoTentarDeNovo` (o pai recria o `lazy`, que guarda a rejeição em cache) e limpa o erro.
 */
export class LimiteDeErroDaJanela extends Component {
    state = { falhou: false };

    static getDerivedStateFromError() {
        return { falhou: true };
    }

    tentarDeNovo = () => {
        this.props.aoTentarDeNovo?.();
        this.setState({ falhou: false });
    };

    render() {
        if (!this.state.falhou) return this.props.children;
        return (
            <Falha role="alert">
                <p>Não consegui carregar o assistente.</p>
                <BotaoTentar type="button" onClick={this.tentarDeNovo}>
                    Tentar de novo
                </BotaoTentar>
            </Falha>
        );
    }
}
